var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import * as Raven from 'raven-js';
import Icon from 'antd/lib/icon';
import message from 'antd/lib/message';
import Modal from 'antd/lib/modal';
import 'antd/lib/message/style/index.css';
import 'antd/lib/modal/style/index.css';
import ButtonAction from '../utilities/ButtonAction';
var selfStyles = require('./ButtonDelete.scss');
var ButtonDelete = (function (_super) {
    __extends(ButtonDelete, _super);
    function ButtonDelete(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isModalVisible: false,
            isModalWaiting: false,
        };
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleDelete = _this.handleDelete.bind(_this);
        return _this;
    }
    ButtonDelete.prototype.handleDelete = function () {
        var _this = this;
        if (typeof this.props.action === 'undefined') {
            return;
        }
        this.props.action()
            .then(this.props.navigateTo)
            .catch(function (err) {
            _this.modal.destroy();
            message.error(err.message);
            Raven.captureException(err);
        });
    };
    ButtonDelete.prototype.handleClick = function () {
        this.modal = Modal.confirm({
            title: this.props.deleteTitle || 'Are you sure?',
            content: this.props.deleteContent || 'No more warnings will be given!',
            okText: 'Delete',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk: this.handleDelete,
        });
    };
    ButtonDelete.prototype.render = function () {
        return (React.createElement(ButtonAction, { className: selfStyles.actionButton, isDisabled: this.props.isDisabled, isWaiting: this.props.isFetching },
            React.createElement("button", { type: 'reset', className: selfStyles.button, onClick: this.handleClick },
                React.createElement(Icon, { type: 'delete' }),
                "Delete")));
    };
    return ButtonDelete;
}(React.Component));
export default ButtonDelete;



//////////////////
// WEBPACK FOOTER
// ./src/pages/components/forms/ButtonDelete.tsx
// module id = 131
// module chunks = 0